import { jsx as _jsx } from "react/jsx-runtime";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as authSelectors from "@rentiohq/shared-frontend/dist/reduxV2/auth/auth.selectors";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { setReturnUrlAfterLogin } from "../../scenes/Auth/Auth.utils";
export var PrivateRoute = function () {
    var hasAccessToken = useSelector(authSelectors.hasAccessToken);
    var location = useLocation();
    var user = authHooks.useSelf().user;
    var _a = user || {}, unverifiedEmail = _a.unverifiedEmail, email = _a.email, unverifiedPhone = _a.unverifiedPhone, unverifiedPhoneIsVerifiable = _a.unverifiedPhoneIsVerifiable;
    if (unverifiedPhone && unverifiedPhoneIsVerifiable) {
        return _jsx(Navigate, { to: { pathname: "/auth/verify/phone" } });
    }
    if (unverifiedEmail) {
        return _jsx(Navigate, { to: { pathname: "/auth/verify/email" } });
    }
    if (!hasAccessToken) {
        // Sign in and come back here, rather than landing on the dashboard. A link
        // in a mail points at one screen, and being dropped on the overview after
        // signing in means finding that screen again by hand. Every sign-in route
        // reads this back through useNavigateAfterSuccess.
        setReturnUrlAfterLogin("".concat(location.pathname).concat(location.search));
        return _jsx(Navigate, { to: { pathname: "/auth/signin" } });
    }
    if (!unverifiedEmail && !email) {
        return _jsx(Navigate, { to: { pathname: "/auth/edit-email" } });
    }
    return _jsx(Outlet, {});
};
